<template>
    <nav class="relative z-0 inline-flex justify-end" aria-label="Pagination">
        <template v-for="(link, key) in links" :key="key">
            <div v-if="link.url === null && key < 3"  class="mr-1 mb-1 px-4 py-3 text-sm leading-4 text-gray-400 border rounded" v-html="link.label" />
            <Link v-else class="mr-1 mb-1 px-4 py-3 text-sm leading-4 border rounded hover:bg-white focus:border-light-pitch-purple focus:text-light-pitch-purple" :class="{ 'bg-gray-100': link.active }" :href="link.url" v-html="link.label" />
        </template> </nav>
</template>

<script>

import { Link } from '@inertiajs/vue3'

export default {
    components: {
        Link
    },
    props: {
        links: Array,
    },
}
</script>
